/* unplugin-vue-components disabled */import { render } from "./privacypolicy.vue?vue&type=template&id=dce88de0&scoped=true"
import script from "./privacypolicy.vue?vue&type=script&lang=js"
export * from "./privacypolicy.vue?vue&type=script&lang=js"

import "./privacypolicy.vue?vue&type=style&index=0&id=dce88de0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dce88de0"]])

export default __exports__